import React, { useState, useEffect } from 'react';
import { initializeGoogleAnalytics, updateGoogleAnalyticsConsent } from '../utils/googleAnalytics';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true, // Always true as these are required
    functional: true, // Always true as these are required
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    } else {
      // Initialize Google Analytics based on existing consent
      const savedConsent = JSON.parse(consent);
      if (savedConsent.analytics) {
        initializeGoogleAnalytics(true);
      }
    }
  }, []);

  const handleAcceptAll = () => {
    const consent = {
      essential: true,
      functional: true,
      analytics: true,
      marketing: true
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    initializeGoogleAnalytics(true);
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    const consent = {
      ...preferences,
      essential: true, // Ensure essential cookies are always true
      functional: true // Ensure functional cookies are always true
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    updateGoogleAnalyticsConsent(consent.analytics);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="w-full max-w-7xl mx-auto px-4 py-4 sm:px-6 sm:py-6 lg:px-8">
        <div className="flex flex-col gap-4">
          <div className="flex-1">
            <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">We value your privacy</h2>
            <p className="text-sm sm:text-base text-gray-700">
              We use cookies to enhance your browsing experience, serve personalised ads or content, and analyse our traffic. By clicking "Accept All", you consent to our use of cookies.
            </p>
          </div>

          {showCustomize ? (
            <div className="space-y-4">
              <div className="space-y-3">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 p-3 rounded gap-2">
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900">Essential Cookies</h4>
                    <p className="text-xs sm:text-sm text-gray-500">Required for the website to function properly. Cannot be disabled.</p>
                  </div>
                  <input
                    type="checkbox"
                    checked={true}
                    disabled
                    className="h-4 w-4 rounded border-gray-300 text-indigo-950 mt-1 sm:mt-0"
                  />
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 p-3 rounded gap-2">
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900">Functional Cookies</h4>
                    <p className="text-xs sm:text-sm text-gray-500">Required for the website to function properly. Cannot be disabled.</p>
                  </div>
                  <input
                    type="checkbox"
                    checked={true}
                    disabled
                    className="h-4 w-4 rounded border-gray-300 text-indigo-950 mt-1 sm:mt-0"
                  />
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 p-3 rounded gap-2">
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900">Analytics Cookies</h4>
                    <p className="text-xs sm:text-sm text-gray-500">Help us improve our website by collecting anonymous usage data.</p>
                  </div>
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
                    className="h-4 w-4 rounded border-gray-300 text-indigo-950 mt-1 sm:mt-0"
                  />
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 p-3 rounded gap-2">
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900">Marketing Cookies</h4>
                    <p className="text-xs sm:text-sm text-gray-500">Used to deliver personalized advertisements.</p>
                  </div>
                  <input
                    type="checkbox"
                    checked={preferences.marketing}
                    onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
                    className="h-4 w-4 rounded border-gray-300 text-indigo-950 mt-1 sm:mt-0"
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
                <button
                  onClick={() => setShowCustomize(false)}
                  className="w-full sm:w-auto px-4 py-2 text-indigo-950 border border-indigo-950 rounded hover:bg-indigo-50 text-sm sm:text-base transition-colors"
                >
                  Back
                </button>
                <button
                  onClick={handleSavePreferences}
                  className="w-full sm:w-auto px-4 py-2 bg-indigo-950 text-white rounded hover:bg-indigo-800 text-sm sm:text-base transition-colors"
                >
                  Save Preferences
                </button>
              </div>
            </div>
          ) : (
            <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
              <button
                onClick={() => setShowCustomize(true)}
                className="w-full sm:w-auto px-6 py-2 text-indigo-950 border border-indigo-950 rounded hover:bg-indigo-50 text-sm sm:text-base transition-colors"
              >
                Customize
              </button>
              <button
                onClick={handleAcceptAll}
                className="w-full sm:w-auto px-6 py-2 bg-indigo-950 text-white rounded hover:bg-indigo-800 text-sm sm:text-base transition-colors"
              >
                Accept All
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
